import React from 'react';
import GlobalHelper from '../../../Common/Helpers/GlobalHelper';

let TableRow = React.createClass({
    render: function () {
        let valor = this.props.row.LimiteCompra;

        if (this.props.novedad !== undefined) {
            let valorNovedad = this.props.novedad.ValorNovedad;
            let valorAnterior = this.props.novedad.ValorAnterior;

            if (this.props.novedadEditado != undefined) {
                if (this.props.novedadEditado.edited) {
                    valor = this.props.novedadEditado.ValorNovedad;
                }
                else {
                    valor = valorNovedad;
                }
            } else {
                valor = valorNovedad;
            }
        }
        
        valor = GlobalHelper.ConvertirNumeroMilesMillones(valor);
        return (
            <div className="row row-bold">
                <div className="col-md-1">
                </div>
                <div className="col-md-5">
                    <label className="label-primary">{this.props.row.Descripcion} ({this.props.row.tipoCuentaDescripcion}):</label>
                </div>
                <div className="col-md-6" onMouseOver={this.overLimite}>
                    <label className="label-secondary">$</label>
                    <label className="label-secondary color-azul-claro">{valor}</label>
                </div>
            </div>
        );
    },

    overLimite: function () {
        this.props.aparicionLapizEdicion(this.props.row.Id);
    }
});

export default TableRow